import { Prop, Component, Vue } from 'vue-property-decorator';

@Component
export default class CustomToolbar extends Vue {

    @Prop({ default: false }) private readonly canBack!: boolean;

    private back(): void {
        if (this.canBack) {
            this.$emit('back');
        }
    }
}